type OwnArgs = {
  isActiveTrade: boolean;
  isTradeInApplied: boolean;
  tradeIncentive?: number;
};

export default function shouldShowTradeIncentive({
  isActiveTrade,
  isTradeInApplied,
  tradeIncentive
}: OwnArgs): boolean {
  const hasTradeIncentive = (tradeIncentive ?? 0) > 0;

  return hasTradeIncentive && isTradeInApplied && isActiveTrade;
}
